/**
 * Labstep
 *
 * @module components/Permission/Manager
 * @desc Displays list of permissions
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { PermissionActionCreate } from 'labstep-web/components/Permission/Action/Create';
import { PermissionExclusiveFolderLoader } from 'labstep-web/components/Permission/ExclusiveFolderLoader';
import { PermissionTable } from 'labstep-web/components/Permission/Table';
import type { Folder } from 'labstep-web/models/folder.model';
import { Permission } from 'labstep-web/models/permission.model';
import type React from 'react';
import type { PermissionManagerProps } from './types';

export const PermissionManager: React.FC<PermissionManagerProps> = ({
  parentEntity,
}) => (
  <PermissionExclusiveFolderLoader parentEntity={parentEntity}>
    {({ exclusiveFolder }: { exclusiveFolder?: Folder }) => {
      const permissionParentEntity = exclusiveFolder
        ? exclusiveFolder
        : parentEntity;
      return (
        <div>
          <PermissionActionCreate
            parentEntity={permissionParentEntity}
          />
          <EntitySearch
            entityName={Permission.entityName}
            params={{
              [`${permissionParentEntity.entityName}_id`]:
                permissionParentEntity.idAttr,
            }}
            hideFilters
            showEmptyStateOnSearchOnly
          >
            {({ entities }) => (
              <PermissionTable
                parentEntity={permissionParentEntity}
                permissions={entities}
              />
            )}
          </EntitySearch>
        </div>
      );
    }}
  </PermissionExclusiveFolderLoader>
);
